import { Box, Button, Tooltip, Typography } from "@mui/material";
import { LIGHT_GREEN } from "styles/oneOffColor";

import { PARTNERSHIP_DATA_EXAMPLE } from "constants/influencer";

const SeeExample = () => {
  return (
    <Tooltip
      enterTouchDelay={0}
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: "white",
            borderRadius: 2,
            overflow: "hidden",
            boxShadow: 3,
          },
        },
      }}
      title={
        <Box>
          <Typography sx={{ fontSize: 12 }}>
            See Partnership Data On Every Brand Card
          </Typography>
          <Box
            component="img"
            sx={{
              width: 280,
            }}
            src={PARTNERSHIP_DATA_EXAMPLE}
          />
        </Box>
      }
    >
      <Button
        sx={{
          fontSize: 10,
          textTransform: "none",
          color: "primary.main",
          ml: 1,
          backgroundColor: LIGHT_GREEN,
          borderRadius: 4,
          px: 2,
          py: 0.5,
        }}
      >
        See Example{" "}
      </Button>
    </Tooltip>
  );
};

export default SeeExample;
